/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * WordpressTokenBase
 * auto generated base class for the model WordpressTokenModel.
 */
export const WordpressTokenModelBase = ModelBase.named('WordpressToken')
  .props({
    __typename: types.optional(types.literal('WordpressToken'), 'WordpressToken'),
    code: types.union(types.undefined, types.number),
    expires_in: types.union(types.undefined, types.number),
    iat: types.union(types.undefined, types.number),
    jwt_token: types.union(types.undefined, types.string),
    token_type: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class WordpressTokenModelSelector extends QueryBuilder {
  get code() {
    return this.__attr('code')
  }
  get expires_in() {
    return this.__attr('expires_in')
  }
  get iat() {
    return this.__attr('iat')
  }
  get jwt_token() {
    return this.__attr('jwt_token')
  }
  get token_type() {
    return this.__attr('token_type')
  }
}
export function selectFromWordpressToken() {
  return new WordpressTokenModelSelector()
}

export const wordpressTokenModelPrimitives = selectFromWordpressToken().code.expires_in.iat.jwt_token.token_type
